var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#71C9BB",
    d: "M10.398 4.748a5.1 5.1 0 0 0-2.07.712c-.622.386-2.589 2.301-2.992 2.914c-.536.814-.583 1.029-.617 2.657c-.026 1.539.043 2.452.249 3.172c.235.822.48 1.165 1.8 2.537c1.35 1.401 1.782 1.766 2.4 2.014a6.6 6.6 0 0 0 4.221.322c2.259-.588 3.973-1.95 4.971-3.943q.494-1.079.845-2.212c.124-.437.103-1.723-.034-2.241c-.438-1.646-1.016-2.739-2.002-3.763a7.5 7.5 0 0 0-3.771-2.074c-.995-.13-2-.162-3-.095m3.531 3.103L14.572 12c-.193 1.294-.497 2.781-.677 4.071l-1.526-.356c.223-1.41.429-2.76.403-2.785c-.013-.013-.064 0-.111.043c-.643.501-3.073 2.323-3.073 2.323l-.93-1.179c.445-.369 2.764-2.186 2.764-2.186L8.658 9.72l.861-1.17l3.257 2.378s-.33-2.515-.394-2.794l1.543-.283z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKas);
export default __webpack_public_path__ + "static/media/kas.a510dce662e21c3a5cbbd1892ade595c.svg";
export { ForwardRef as ReactComponent };